<div class="flex-column">
  <div>
    @if (showAllocationMessage) {
    <div class="alert alert-danger">{{ allocationMessage }}</div>
    }
    <div class="summary-header">
      <span class="header-lable-sm">Total Project Allocation: </span><span>{{ projectTotalAllocation | percent:'2.2-4' }}</span>
    </div>
    <div class="panelbar-wrapper">
      @for (assetMappingConfiguration of assetMappingConfigurations | async; track assetMappingConfiguration) {
      <kendo-panelbar #mappingPanelBar [keepItemContent]="true">
        <kendo-panelbar-item [title]="assetMappingConfiguration.ModuleProperties?.Name ?? ''" [expanded]="moduleExpandMap.get(assetMappingConfiguration.AssetMappingConfigurationId) ?? false">
          <ng-template kendoPanelBarContent>
            <div class="allocation-module">
              @switch (assetMappingConfiguration.ModuleId) {
              @case (module.Asset) {
              <div> <!-- Asset -->
                <app-project-asset-mapping-general-asset
                  [projectId]="projectTab().ProjectId"
                  [projectTypeId]="projectTab().ProjectTypeId"
                  [project]="projectTab().Project"
                  [assetTeamId]="projectTab().AssetTeamId"
                  [assetMappingConfig]="assetMappingConfiguration"
                  [projectAssetMappingService]="projectTab().ProjectAssetMappingService">
                </app-project-asset-mapping-general-asset>
              </div>
              }
              @case (module.WellDetails) {
              <div> <!-- Well Details -->
                <app-project-asset-mapping-well-details
                  [projectId]="projectTab().ProjectId"
                  [projectTypeId]="projectTab().ProjectTypeId"
                  [assetTeamId]="projectTab().AssetTeamId"
                  [scenarioId]="projectTab().ScenarioId"
                  [project]="projectTab().Project"
                  [assetMappingConfig]="assetMappingConfiguration"
                  [projectAssetMappingService]="projectTab().ProjectAssetMappingService"
                  (owidFlag)="readOwidFlag($event)">
                </app-project-asset-mapping-well-details>
              </div>
              }
              @case (module.MultiWell) 
              @case (module.MultiWellSwdVertical) {
              <div> <!-- Multi Well Table / Multi-Well SWD/Vertical Table -->
                <app-project-asset-mapping-multi-well
                  [projectId]="projectTab().ProjectId"
                  [projectTypeId]="projectTab().ProjectTypeId"
                  [projectSubTypeId]="projectTab().ProjectSubTypeId"
                  [project]="projectTab().Project"
                  [assetMappingConfig]="assetMappingConfiguration"
                  [projectAssetMappingService]="projectTab().ProjectAssetMappingService">
                </app-project-asset-mapping-multi-well>
              </div>
              }
              @case (module.MultiAsset) {
              <div> <!-- Multi Asset Table -->
                <app-project-asset-mapping-multi-asset
                  [projectId]="projectTab().ProjectId"
                  [project]="projectTab().Project"
                  [assetMappingConfig]="assetMappingConfiguration"
                  [projectAssetMappingService]="projectTab().ProjectAssetMappingService">
                </app-project-asset-mapping-multi-asset>
              </div>
              }
              @case (module.CostCenter) {
              <div> <!-- Cost Center -->
                <app-project-asset-mapping-cost-center
                  [projectId]="projectTab().ProjectId"
                  [project]="projectTab().Project"
                  [assetMappingConfig]="assetMappingConfiguration"
                  [projectAssetMappingCostCenterService]="projectTab().ProjectAssetMappingCostCenterService"
                  [projectAssetMappingService]="projectTab().ProjectAssetMappingService">
                </app-project-asset-mapping-cost-center>
              </div>
              }
              }
            </div>
          </ng-template>
        </kendo-panelbar-item>
      </kendo-panelbar>
      }
    </div>
  </div>
</div>